import type { StateCreator } from "zustand"
import { create } from "@/app/state"

interface DeleteFlashcardModalState {
  isOpen: boolean
  flashcardId: string
  openModal: (flashcardIdToDelete: string) => void
  closeModal: () => void
}

const state: StateCreator<DeleteFlashcardModalState> = (set) => ({
  isOpen: false,
  flashcardId: "",
  openModal: (flashcardIdToDelete: string) =>
    set({ isOpen: true, flashcardId: flashcardIdToDelete }),
  closeModal: () => set({ isOpen: false, flashcardId: "" }),
})

export const useDeleteFlashcardModal = create<DeleteFlashcardModalState>()(state)
